import Video from './Video';

export default class AutoplayVideos {
	constructor() {
		if (!'IntersectionObserver' in window) {
			return;
		}

		this.reduceMotionMediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

		this.intersectionObserver = new IntersectionObserver(this.handleIntersection.bind(this), {
			rootMargin: '200px',
		});

		document.addEventListener('bless', (e) => {
			const container = e.target;
			this.init(container);
		});
	}

	init(container) {
		const autoplayVideos = container.querySelectorAll('[data-autoplay-video]');
		autoplayVideos.forEach((autoplayVideo) => {
			new Video(autoplayVideo);
			if (this.reduceMotionMediaQuery.matches) {
				autoplayVideo.dispatchEvent(new CustomEvent('show-poster'));
				return;
			}
			const autoplay = autoplayVideo.dataset['autoplayVideo'];
			if (autoplay === 'true') {
				this.intersectionObserver.observe(autoplayVideo);
				autoplayVideo.dispatchEvent(new CustomEvent('init'));
			}

		});
	}

	handleIntersection(entries) {
		entries.forEach((entry) => {
			const ratio = entry.intersectionRatio;
			const target = entry.target;

			// Video is in viewport
			if (ratio > 0) {
				target.dispatchEvent(new CustomEvent('play-video'));
			} else {
				// Video is outside viewport and ready to be paused
				target.dispatchEvent(new CustomEvent('pause-video'));
			}
		});
	}
}
